module.exports = __webpack_public_path__ + "static/media/maera_25kz.7e08acde.pdf";